module.exports = {
  cashRegisterPrefix: 'Cash Register/',

  allowedStatementAttachments:  {
    'image/*': ['.png', '.jpg', '.jpeg'],
    'application/pdf': ['.pdf'],
  },
}
